import { create } from "zustand";

type ThemeMode = "light" | "dark" | "system";

interface ThemeState {
  mode: ThemeMode;
  isDark: boolean;
  setMode: (mode: ThemeMode) => void;
}

function resolveIsDark(mode: ThemeMode): boolean {
  if (mode === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
  return mode === "dark";
}

function loadMode(): ThemeMode {
  const stored = localStorage.getItem("agents-web:theme");
  if (stored === "light" || stored === "dark") return stored;
  return "system";
}

export const useThemeStore = create<ThemeState>((set) => {
  const mode = loadMode();
  const isDark = resolveIsDark(mode);

  // Listen for system theme changes
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  mq.addEventListener("change", () => {
    set((state) => {
      if (state.mode !== "system") return state;
      return { isDark: mq.matches };
    });
  });

  return {
    mode,
    isDark,
    setMode: (mode) => {
      if (mode === "system") {
        localStorage.removeItem("agents-web:theme");
      } else {
        localStorage.setItem("agents-web:theme", mode);
      }
      set({ mode, isDark: resolveIsDark(mode) });
    },
  };
});
